import { Injectable, signal, TemplateRef, untracked} from '@angular/core';

import {AppError, AppErrorAction} from "../../lib/shared/errors/app-error";
import {renderMessageText} from "../../lib/shared/errors/message-text";
import {config} from "../../config";

@Injectable({
  providedIn: 'root'
})
export class UiService {


  dimming = signal<{
    dimmed: boolean,
    title: string,
    message?: string,
    /** Class on the support links in a stop message; Piwik tracks the clicks by it. */
    supportLinkClass?: string,
    asStopMessage: boolean,
    asAppLoading?: boolean,
    dimLevel: number,
    action: { label: string, onClick: AppErrorAction } | null
  }>({
    action: null,
    asStopMessage: false,
    asAppLoading: false,
    dimLevel: 0.9,
    dimmed: false,
    title: ""
  }, {
    equal: (a, b) => {
      if (a.dimmed !== b.dimmed) {
        return false;
      }
      if ((a.title ?? '') !== (b.title ?? '')) {
        return false;
      }
      if ((a.message ?? '') !== (b.message ?? '')) {
        return false;
      }
      if ((a.supportLinkClass ?? '') !== (b.supportLinkClass ?? '')) {
        return false;
      }
      if (a.asStopMessage !== b.asStopMessage) {
        return false;
      }
      if (a.dimLevel !== b.dimLevel) {
        return false;
      }
      if (a.action !== b.action) {
        return false;
      }
      return true;
    }
  });

  sidebar = signal<{
    template: TemplateRef<unknown>,
    headerTemplate?: TemplateRef<unknown>,
    actions?: { label: string, action: () => void }[]
  } | null>(null);

  hideStopMessage() {
    const currentIsStop = this.dimming().asStopMessage;
    if (!currentIsStop) {
      return;
    }
    this.dimming.set({
      dimmed: false,
      title: '',
      asStopMessage: false,
      dimLevel: 0.9,
      action: null
    });
  }

  hideLoading(options?: { ignoreError?: boolean, onlyIfAppLoading?: boolean }) {
    const currentIsStop = this.dimming().asStopMessage;
    if (!options?.ignoreError && currentIsStop) {
      return;
    }
    if (options?.onlyIfAppLoading && !this.dimming().asAppLoading) {
      return;
    }

    this.dimming.set({
      dimmed: false,
      title: '',
      asStopMessage: false,
      dimLevel: 0.9,
      action: null
    });
  }

  showError(error: AppError, supportLinkClass?: string) {

    untracked(() =>
      this.dimming.set({
        dimmed: true,
        // the card renders its title as plain text, so a placeholder there becomes the bare number
        title: renderMessageText(error.title, config.support),
        message: error.message,
        supportLinkClass,
        asStopMessage: true,
        dimLevel: 0.9,
        action: error.options?.action ?? null,
      }));
  }

  showAppLoading() {
    untracked(() => this.dimming.set({
      dimmed: true,
      title: 'Loading...',
      asAppLoading: true,
      asStopMessage: false,
      dimLevel: 0.9,
      action: null
    }));
  }
  showLoading(title: string, msg?: string) {
    untracked(() => this.dimming.set({
      dimmed: true,
      title,
      message: msg,
      asStopMessage: false,
      dimLevel: 0.9,
      action: null
    }));
  }
}
